<template>
  <div id="results-page">
    <div id="results-results">
      <div class="block-title">Rezultati</div>

      <f7-list media-list>
        <f7-list-item v-for="(result, idx) in results"
                      :key="'result' + idx">
          <div slot="title" v-html="result.name"></div>
          <div slot="text" v-html="result.description"></div>
          <div slot="subtitle" v-html="String(result.value)"></div>
        </f7-list-item>
      </f7-list>
    </div>

    <div id="results-answers">
      <div class="block-title">Odgovori</div>
      <f7-list class="question-group-list">
        <f7-list-item v-for="(questionGroup, qgIdx) in answeredQuestions.questionGroups" :key="'qg' + qgIdx">
          <f7-block class="question-group-block">
            <f7-block-header><span v-html="questionGroup.question"></span></f7-block-header>
            <span v-html="questionGroup.description"></span>
          </f7-block>

          <f7-list media-list tablet-inset no-hairlines no-hairlines-between class="question-list">
            <f7-list-item v-for="question in questionGroup.questions"
                          :key="question.id">
              <div slot="subtitle" v-html="question.question"></div>
              <div slot="text" v-html="question.getSelectedAnswer() !== null ? question.getSelectedAnswer().description : '/'"></div>
            </f7-list-item>
          </f7-list>
        </f7-list-item>
      </f7-list>
    </div>

    <div id="results-patient-info">
      <div class="block-title">Podatki o bolniku</div>
      <div class="list inline-labels no-hairlines-md">
        <ul>
          <li class="item-content item-input">
            <div class="item-media">
              <i class="icon demo-list-icon"></i>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">Ime/Šifra:</div>
              <div class="item-input-wrap">
                <input type="text" placeholder="Metka Novak (1532453)">
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-media">
              <i class="icon demo-list-icon"></i>
            </div>
            <div class="item-inner">
              <div class="item-title item-label">Datum:</div>
              <div class="item-input-wrap">
                <input type="text" :value="getFormattedDate()" placeholder="Datum testa" id="results-test-date">
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <f7-block strong id="results-print">
      <f7-button fill raised @click="print()">Natisni</f7-button>
    </f7-block>

  </div>
</template>

<script>

export default {
  name: 'Results',
  props: ['answeredQuestions', 'results'],
  methods: {
    print: function () {
      window.print()
    },
    getFormattedDate: function () {
      const today = new Date()
      return `${today.getDate()}.${today.getMonth() + 1}.${today.getFullYear()}`
    }
  }
}
</script>

<style lang="scss" scoped>
  #results-page /deep/ {
    @media print {

      display: flex;
      flex-direction: column;

      .input-clear-button {
        display: none;
      }

      .md .item-input-focused .item-label, .md .item-input-focused .item-floating-label {
        color: inherit !important;
      }

      .md .item-input-focused .item-input-wrap:after, .md .input-focused:after {
        background: inherit !important;
      }

      ::-webkit-input-placeholder { /* WebKit browsers */
        color: transparent !important;;
      }
      :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: transparent !important;;
      }
      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: transparent !important;;
      }
      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: transparent !important;
      }

      .block-title {
        margin-top: 10px;
        margin-bottom: 5px;
      }

      #results-print {
        display: none;
      }

      #results-patient-info {
        position: absolute;
        width: 7cm;
        right: 0;
        top: -70px;
        order: 0;
        z-index: 100000;

        .item-inner {
          padding: 0;
        }

        .item-title {
          padding: 3px 0 0 0;
        }

        .item-content, .item-inner, .item-input-wrap, .item-input-wrap * {
          padding: 0;
          min-height: 0;
          height: 25px;
          line-height: 24px;
        }

        .item-inner * {
          font-size: 10pt;
        }

        .item-input-wrap:after {
          display: none;
        }

        .item-title {
          text-align: right;
        }

        .item-media {
          display: none;
        }

        .block-title {
          display: none;
        }
      }

      #results-results {
        order: 1;

        ul .item-inner {
          .item-title-row {
            width: 80%;
            float: left;
          }

          .item-subtitle {
            width: 20%;
            float: left;
            text-align: right;
          }

          .item-text {
            width: 100%;
            float: left;
            font-size: 9pt;
          }
        }
      }

      #results-answers {
        order: 2;

        .question-group-block {
          padding-left: 0;
        }

        .list {
          margin-bottom: 20px;
          margin-left: 0;
          margin-right: 0;

          .item-content {

            display: block;
            min-height: 0;

            .item-inner {
              display: block;
              padding-top: 5px;
              padding-bottom: 5px;
              line-height: 18px;
              min-height: 18px;

              .block {
                margin-top: 5px;
                margin-bottom: 5px;
              }
            }
          }
        }

        .list.question-list ul {

          padding-left: 0.8cm;

          .item-content {

            page-break-inside: avoid;

            .item-inner {

              padding-right: 0;

              .item-subtitle {
                display: inline-block;
                white-space: normal;
              }

              .item-text {
                display: inline-block;
                float: right;
                padding-left: 1cm;
              }
            }
          }
        }
      }

    }

    #results-answers {

      .question-list ul {
        padding-left: 40px;
      }

      .list {
        margin-bottom: 20px;
        margin-left: 0;
        margin-right: 0;

        .item-content {

          display: block;
          min-height: 0;

          .item-inner {
            display: block;
            padding-top: 5px;
            padding-bottom: 5px;
            line-height: 18px;
            min-height: 18px;

            .block {
              margin-top: 5px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }

    #results-answers .item-subtitle {
      text-after-overflow: none;
      white-space: initial;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Results.vue